import { h, Component } from 'preact';
import { Link } from 'preact-router/match';
import style from './style';

export default class Header extends Component {
	render() {
		return (
			<header class={style.header}>
				<h1>TMS</h1>
				<nav>
					<Link activeClassName={style.active} href="/">NKJV</Link>
					<Link activeClassName={style.active} href="/niv">NIV</Link>
					<Link activeClassName={style.active} href="/esv">ESV</Link>
				</nav>
			</header>
		);
	}
}



// WEBPACK FOOTER //
// ./components/header/index.js